/* GARDENMAC — video "protetto" (30/09/2026). Stesso meccanismo della hero
   (sections/gm-hero-porsche.liquid): il file sul CDN e' un binario cifrato con XOR a
   chiave ripetuta, si scarica a pezzi, si decifra in memoria e si passa al
   MediaSource (o a un blob dove manca). Uso: window.gmVideoProtetto(video, url).
   La chiave e' la stessa della hero: se cambia li', cambia anche qui. */
window.gmVideoProtetto = function (video, url) {
    var CHIAVE = (function (h) { var k = new Uint8Array(h.length / 2); for (var i = 0; i < k.length; i++) { k[i] = parseInt(h.substr(i * 2, 2), 16); } return k; })('630f0fb063d79fec46c17db5d21563b5e27ddfdebc8d57b8be828311d7336c6e');
    function svela(b, da) { var kl = CHIAVE.length; for (var i = 0; i < b.length; i++) { b[i] ^= CHIAVE[(da + i) % kl]; } return b; }
    function codecsDa(b) {
      for (var i = 0; i + 8 < b.length; i++) {
        if (b[i] === 0x61 && b[i + 1] === 0x76 && b[i + 2] === 0x63 && b[i + 3] === 0x43) {
          var h = function (x) { return ('0' + x.toString(16)).slice(-2); };
          return 'avc1.' + h(b[i + 5]) + h(b[i + 6]) + h(b[i + 7]);
        }
      }
      return '';
    }
    function unisci(a, b) { var c = new Uint8Array(a.length + b.length); c.set(a, 0); c.set(b, a.length); return c; }
    var parti = function () { var p = video.play(); if (p && p.catch) { p.catch(function () {}); } };
    function avviaProtetto(url) {
      var MS = window.ManagedMediaSource || window.MediaSource;
      var tipoOk = function (c) { try { return !!c && MS.isTypeSupported('video/mp4; codecs="' + c + '"'); } catch (e) { return false; } };
      var fallito = false;
      var conBlob = function () {
        fetch(url, { credentials: 'omit' }).then(function (r) { return r.arrayBuffer(); }).then(function (ab) {
          var b = svela(new Uint8Array(ab), 0);
          video.src = URL.createObjectURL(new Blob([b], { type: 'video/mp4' }));
          video.load(); parti();
        }).catch(function () {});
      };
      if (!MS || !window.ReadableStream || !window.fetch) { conBlob(); return; }
      var ms = new MS(), sb = null, coda = [], finito = false, letto = 0, testa = null;
      if (window.ManagedMediaSource && MS === window.ManagedMediaSource) { video.disableRemotePlayback = true; }
      var cedi = function () { if (!fallito) { fallito = true; conBlob(); } };
      var spingi = function () {
        if (fallito || !sb || sb.updating) { return; }
        if (coda.length) { try { sb.appendBuffer(coda.shift()); } catch (e) { cedi(); } }
        else if (finito && ms.readyState === 'open') { try { ms.endOfStream(); } catch (e) {} }
      };
      ms.addEventListener('sourceopen', function () {
        fetch(url, { credentials: 'omit' }).then(function (r) {
          var reader = r.body.getReader();
          var leggi = function () {
            reader.read().then(function (res) {
              if (fallito) { return; }
              if (res.done) { finito = true; if (testa) { coda.push(testa); testa = null; } spingi(); return; }
              var b = svela(res.value, letto); letto += b.length;
              if (!sb) {
                testa = testa ? unisci(testa, b) : b;
                var c = codecsDa(testa);
                if (!c && testa.length < 262144) { leggi(); return; }
                if (!tipoOk(c)) { reader.cancel(); cedi(); return; }
                sb = ms.addSourceBuffer('video/mp4; codecs="' + c + '"');
                sb.addEventListener('updateend', spingi);
                sb.addEventListener('error', cedi);
                b = testa; testa = null;
              }
              coda.push(b); spingi(); leggi();
            }).catch(cedi);
          };
          leggi();
        }).catch(cedi);
      }, { once: true });
      video.src = URL.createObjectURL(ms);
      parti();
    }

    avviaProtetto(url);
};
